"use strict";

(() => {

const templates = {
    filterItem: `<div data-title="[[FILTER_TITLE]]" data-attr-key="[[FILTER_ATTR_KEY]]" class="widget sidebar-tags [[FILTER_ACCORDION_CLASS]]" role="region" aria-labelledby="filter-[[FILTER_ATTR_KEY]]">
                    <div class="widget-title">
                        <div class="sidebar-title" role="button" tabindex="0" [[FILTER_ACCORDION_ATTR]] id="filter-[[FILTER_ATTR_KEY]]" aria-controls="filter-content-[[FILTER_ATTR_KEY]]">
                            <span>[[FILTER_TITLE]] </span>
                            [[FILTER_SELECTED_COUNT]]
                        </div>
                    </div>
                    <div class="widget-content filter_search_wrapper collection-price-range" data-filter-option-container [[FILTER_ACCORDION_STYLE]] id="filter-content-[[FILTER_ATTR_KEY]]" role="group">
                        <ul class="list-tags scroller" role="list">
                            [[FILTER_OPTIONS]]
                        </ul>
                    </div>
                </div>`,
    filterOption: `<li role="listitem">
                        <input aria-controls="sr-status" type="checkbox" id="[[FILTER_OPTION_ID]]" value="[[FILTER_OPTION_VALUE]]" [[FILTER_OPTION_SELECTED]] />
                        <label for="[[FILTER_OPTION_ID]]">[[FILTER_OPTION_TITLE]]</label>
                    </li>`,
    filterPriceOption: ` <li data-value="Price" class="price-filter">
                            <div class="price-selected">
                                <span id="price-selected-min" class="price-selected-col price-selected-min" aria-live="assertive" data-min-price="[[PRICE_LEFT]]">
                                    <span class="visually-hidden">minimum price [[PRICE_LEFT]]</span>
                                    <span aria-hidden="true">[[PRICE_LEFT]]</span>
                                </span>
                                <span id="price-selected-max" class="price-selected-col price-selected-max" aria-live="assertive" data-max-price="[[PRICE_RIGHT]]">
                                    <span class="visually-hidden">maximum price [[PRICE_RIGHT]]</span>
                                    <span aria-hidden="true">[[PRICE_RIGHT]]</span>
                                </span>
                            </div>
                            <div id="filter-price-range"></div>
                            <div class="price-range-info">
                                <input type="text" aria-label="minimum price [[PRICE_FROM]]" class="price-range-info-min" data-price-from="[[PRICE_FROM_UNFORMATTED]]" value="[[PRICE_FROM]]" tabindex="-1" readonly />
                                <input type="text" aria-label="maximum price [[PRICE_TO]]" class="price-range-info-max" data-price-to="[[PRICE_TO_UNFORMATTED]]" value="[[PRICE_TO]]" tabindex="-1" readonly />
                                <input type="hidden" name="restrictBy[price]" class="price-range-full" value="[[PRICE_FROM_TO_UNFORMATTED]]" readonly />
                            </div>
                        </li>`
};

class SearchanizeProducts extends HTMLElement {

    settings = {
        cachedData: {},
        startIndex: 0,
        currentPage: 0,
        isLoading: false,
        isLoadMore: false,
        isPriceFilter: false,
        renderOfferTemplate: false,
        infiniteScrollObserver: null,
        isMobile: window.innerWidth <= 768,
        similarProductTotalItems: 0,
        similarProductStartIndex: 0,
        similarProductCurrentPage: 0,
        similarProductItemsPerPage: 15,
    };

    constructor() {
        super();
        const self = this;
        this.searchQuery = '';
        this.productHandle = '';
        this.pageType = this.getAttribute('data-page-type');
        this.isShowingSimilarProducts = false;

        if (this.pageType === 'search') {
            this.collectionHandle = '';
        } else {
            this.collectionHandle = this.getAttribute('data-handle');
            if(!this.collectionHandle) return;

            if (this.collectionHandle.includes("2-for-99") || this.collectionHandle.includes("flash-sale")) {
                this.settings.renderOfferTemplate = true;
            }
        }

        this.buildSelectors();
        this.fetchProducts(true);
    }

    buildSelectors(){
        this.selectors = {};
        this.selectors.overlay = document.querySelector('.wrapper-overlay');
        
        this.selectors.srStatus = this.querySelector('#sr-status');
        this.selectors.mainContainer = this.querySelector('[data-main-container]');

        this.selectors.filterContainer = this.querySelector('[data-mobile-filter] [data-filter-container]');
        this.selectors.productsContainer = this.querySelector('[data-products-container]');
        
        this.selectors.mobFilterOpen = this.querySelector('[data-mob-filter-open]');
        this.selectors.mobFilterClose = this.querySelectorAll('[data-mob-filter-close]');
        this.selectors.filterButtons = this.querySelector('[data-filter-buttons]');

        this.selectors.sortByDiv = this.querySelector('[data-sortby]');
        this.selectors.sortByBtn = this.querySelector('[data-sortby] [data-sortby-btn]');
        this.selectors.sortByList = this.querySelector('[data-sortby] [data-sortby-list]');

        this.selectors.loadMoreBtn = this.querySelector('[data-loadmore-btn]');
        this.selectors.productCounts = this.querySelectorAll('[data-result-count]');

        this.selectors.productsBannerTop = this.querySelector('[data-banner-top]');
        this.selectors.searchQuery = this.querySelector('[data-search-query]');

        this.selectors.clearAllBtns = this.querySelectorAll('[data-filter-clear-all]');
        this.selectors.viewAllBtnMob = this.querySelector('[data-mob-filter-close].apply-mob-filter');
        this.selectors.clearAllBtnMob = this.querySelector('[data-filter-clear-all].clear-mob-filter');
        this.collectionDefaultEnable = this.getAttribute('data-collection-defult-enable');
        this.collectionDefaultSorting = this.getAttribute('data-collection-defult-sorting');
    }
    buildAPIURL(initialRender){   
        
        let baseurl = 'https://www.searchanise.com/getresults?api_key=4R1a4a6e9W&items=true&facets=true&facetsShowUnavailableOptions=false&output=jsonp';
        
        const selectedFilterValues = Array.from(
            this.selectors.filterContainer.querySelectorAll('[data-attr-key]')
        ).map(filterItem => {
            let values = '';
            const attrKey = filterItem.dataset.attrKey;
            const selectedInputs = Array.from(filterItem.querySelectorAll('[data-filter-option-container] input[type="checkbox"]:checked'));

            if(attrKey == 'price' && this.settings.isPriceFilter){
                let min = filterItem.querySelector('[data-filter-option-container] ul li .price-selected #price-selected-min').getAttribute('data-min-price');
                let max = filterItem.querySelector('[data-filter-option-container] ul li .price-selected #price-selected-max').getAttribute('data-max-price');

                min = min.replace("$", "");
                max = max.replace("$", "");
                values = min +','+ max;
                selectedInputs.length = 1;
            } else {
                values = selectedInputs.map(input => encodeURIComponent(input.value.trim())).join('|');
            }

            return selectedInputs.length === 0 ? '' : `restrictBy[${attrKey}]=${values}`;
        }).filter(value => value);

        const selectedShowValue = '18';
       
        if(selectedFilterValues.length) baseurl += `&${selectedFilterValues.join('&')}`;

       


        baseurl += this.collectionSorting(initialRender,baseurl);
        baseurl += `&startIndex=${this.settings.startIndex}&maxResults=${selectedShowValue}`;

        const url_obj = new URL(window.location.href);
        this.searchQuery = url_obj.searchParams.get('q') || '';
        if (this.searchQuery && this.pageType === 'search') {
            baseurl += `&q=${encodeURIComponent(this.searchQuery)}`;
        }

        if (this.collectionHandle != '' && this.pageType === 'collection') {
            baseurl += `&categories=true&collection=${this.collectionHandle}`;
        }

        return baseurl;
    }

   collectionSorting(initialRender,baseurl){
     let selectedSortByValue = this.selectors.sortByList.querySelector('[aria-selected="true"][data-value]')?.getAttribute('data-value') || 'sales_amount&sortOrder=desc';

      if (initialRender) {
            if (
            this.collectionDefaultEnable == 'true' ||
            this.collectionDefaultEnable == true
            ) {
            if (this.collectionDefaultSorting.indexOf('price-descending') > -1) {
                selectedSortByValue = 'price&sortOrder=desc';
            } else if (this.collectionDefaultSorting.indexOf('price-ascending') > -1) {
                selectedSortByValue = 'price&sortOrder=asc';
            } else if (this.collectionDefaultSorting.indexOf('created-descending') > -1) {
                selectedSortByValue = 'created&sortOrder=desc';
            } else if (this.collectionDefaultSorting.indexOf('best-selling') > -1) {
                selectedSortByValue = 'sales_amount&sortOrder=desc';
            } else if (this.collectionDefaultSorting.indexOf('manual') > -1) {
                selectedSortByValue = 'sales_amount&sortOrder=desc';
            }
            baseurl += `&sortBy=${selectedSortByValue}`;
                const element = document.querySelector(
                    '.filter-sortby .dropdown-menu li[data-value="' + selectedSortByValue + '"] span:not(.visually-hidden)'
                );
            if (element) {
                // Update label text
                const labelText = document.querySelector(
                '.filter-sortby .label-text'
                );
                if (labelText) {
                labelText.textContent = element.textContent;
                }

                // Set selected state for the target element
                element.setAttribute('aria-selected', 'true');
                element.classList.add('active');

                // Remove selected state from other elements
                const allElements = document.querySelectorAll('.filter-sortby .dropdown-menu li');
                allElements.forEach((el) => {
                if (el.getAttribute('data-value') !== selectedSortByValue) {
                    el.setAttribute('aria-selected', 'false');
                    el.classList.remove('active');
                }
                });
            }
            } else {
            baseurl += `&sortBy=${selectedSortByValue}`;
            }
        } else {
            baseurl += `&sortBy=${selectedSortByValue}`;
        }
        return baseurl
    }
    async fetchProducts(initialRender) {

        try {
            _theme.toggleLoading(true);

            // Handle similar product load more
            if (this.isShowingSimilarProducts && !initialRender) {
                return await this.loadMoreSimilarProducts();
            }

            const apiUrl = this.buildAPIURL(initialRender);
            if(!apiUrl) { throw new Error('Invalid API URL'); }
            
            if(this.settings.infiniteScrollObserver) {
                this.settings.infiniteScrollObserver.unobserve(this.selectors.loadMoreBtn);
            }
            
            let result = null;
            this.settings.isLoading = true;
            this.updateSRStatus();

            if(this.settings.cachedData[apiUrl]) {
                result = this.settings.cachedData[apiUrl];
            } else {
                const resp = await fetch(apiUrl);
                if(!resp.ok) { throw new Error(`Error: ${resp}`); }

                result = await resp.json();
                if(!result) { throw new Error('Invalid Response'); }
                
                this.settings.cachedData[apiUrl] = result;
            }

            if(result.totalItems === 0){
                if (this.pageType === 'search') {
                    // Try to get similar products using fuzzy matching
                    this.trySimilarProducts();
                } else {
                    this.selectors.mainContainer.querySelector('[data-toolbar-container]').classList.add('hidden');
                    this.selectors.mainContainer.querySelector('[data-collection-info]').classList.add('hidden');
                    this.selectors.productsContainer.style.display = 'unset';
                    this.selectors.productsContainer.innerHTML = '<h1 class="col-12 text-center" style="font-size:22px;">Sorry, there are no products in this collection</h1>'; 
                }
            } else {
                this.renderProducts(result);
                this.renderFilters(result);
                if(initialRender){
                    this.initInitialEvents();
                }
                this.initInfiniteScrollLoadMore(result);
                this.settings.isLoadMore = false;
                this.settings.isLoading = false;
                _theme.initSmartWishlist();

                // Filter buttons
                this.selectors.deskFilterOpen = this.querySelectorAll('[data-desk-filter-open]');
                this.selectors.deskFilterOpen.forEach(btn => {
                    btn.addEventListener('click', this.openMobSidebarFilter.bind(this));
                });

                // Clear button
                const filterInputs = this.selectors.filterContainer.querySelectorAll('[data-filter-option-container] input[type="checkbox"]');
                const anyChecked = Array.from(filterInputs).some(checkbox => checkbox.checked);
                this.selectors.clearAllBtnDesk = this.querySelector('[data-filter-clear-all].clear-desk-filter');
                this.selectors.clearAllBtnDesk.style.display = anyChecked ? 'block' : 'none';
                this.selectors.clearAllBtnDesk.addEventListener('click', evt => {
                    filterInputs.forEach(input => {
                        input.checked = false;
                    });

                    this.settings.isPriceFilter = false;
                    this.resetFilters();
                    this.fetchProducts(false);
                });

            }

            if (this.pageType === 'search') {
                if(this.selectors.searchQuery) {
                    this.selectors.searchQuery.innerHTML = `We could not find anything for “${this.searchQuery}” ${result.totalItems} Result`;
                }
            }
            
            setTimeout(() => {
                this.updateSRStatus();
                _theme.toggleLoading(false);
            }, 500)
            
        } catch (error) {
            console.error('Error:', error);
            _theme.toggleLoading(false);
        }
    }

    renderProducts(result){
        if(!result || result.totalItems === 0) return;

        let count = 0;
        let mainHtml = '';

        result.items.forEach((product, index) => {

            count = count + 1;
            this.productHandle = product.link.split('products/')[1];
            const productImages = this.buildProductImage(product);
            const maxDiscountData = this.getMaxDiscountAndvariant(product);
            const productUrl = (maxDiscountData.availableMaxDiscountVariant && maxDiscountData.availableMaxDiscountVariant.link) || product.link;
            const collectionUrl = '/collections/' + _theme.Helpers.handleize(product.vendor) || '';
            const variant_barcode_available = product.shopify_variants
              .filter(variant => {
                  return variant.available == true || variant.available == 1 || variant.available == '1';
              })
              .map(variant => ({
                  barcode: variant.barcode,
                  available: variant.available, // Optional (since we already filtered)
                  brightperlInventory: variant.search_variant_metafields_data.variant_metafield_69f1d8722b9c470908fa53fe850945fb,
                  allowExpressShipping: variant?.search_variant_metafields_data?.variant_metafield_070071a13a8ea5aafeb0b99afa0c101f
              }));

            let vid = '';
            let variant = product.shopify_variants?.find(v => v.available != "0");
            if(!variant) vid = product.shopify_variants[0].variant_id;
            else vid = variant.variant_id;
            
            let prodType = '';
            if(product.metafield_9e14d49086f4ac1134f463aa2738d80e != undefined) {
                prodType = product.metafield_9e14d49086f4ac1134f463aa2738d80e
            } else if(product.product_type !== undefined) {
                prodType = product.product_type
            }

            let variantClass = 'multiple-variant';
            let variantLength = product.shopify_variants.length;
            if(variantLength && variantLength === 1) { variantClass = 'single-variant'; }

            let prodUrl = productUrl;
            const flashVariants = product.shopify_variants.filter(
              (variant) =>
                variant.search_variant_metafields_data?.variant_metafield_7196e689a0a0c382ce7f6b23dbe610ca === 'true' &&
                variant?.available !== '0'
            );

            // Check if timer is active and flash sale extension shop metafield is active
            const timerSettings = window.countdownTimerSettings || {};
            const isTimerActive = this.isTimerActive(timerSettings);
            const flashSaleExtensionActive = timerSettings.flashSaleExtensionActive === true;

            // Check if any flash variant exists and timer is active and flash sale extension shop metafield is active
            if (flashVariants.length > 0 && isTimerActive && flashSaleExtensionActive) {
              const flsVar = flashVariants[0];
              if (flsVar != undefined && flsVar != null) {
                prodUrl = flsVar.link;
              }
            }

            let product_html = this.settings.renderOfferTemplate ? _theme.product_html.productGridOffer : _theme.product_html.productGridNew;
            
            product_html = _theme.Helpers.updateHtml(product_html, '[[Variant_Id]]', vid);
            product_html = _theme.Helpers.updateHtml(product_html, '[[shipping_info_variants]]', JSON.stringify(variant_barcode_available));
            product_html = _theme.Helpers.updateHtml(product_html, '[[Product_Id]]', product.product_id);
            product_html = _theme.Helpers.updateHtml(product_html, '[[Product_URL]]', prodUrl);
            product_html = _theme.Helpers.updateHtml(product_html, '[[Product_URL]]', productUrl);
            product_html = _theme.Helpers.updateHtml(product_html, '[[Product_Title]]', product.title);
            product_html = _theme.Helpers.updateHtml(product_html, '[[Product_Type_Meta]]', prodType);
            product_html = _theme.Helpers.updateHtml(product_html, '[[Product_Image_1]]', productImages.image_1);
            product_html = _theme.Helpers.updateHtml(product_html, '[[Product_Vendor]]', product.vendor || '');
            product_html = _theme.Helpers.updateHtml(product_html, '[[Product_Vendor_Url]]', collectionUrl);
            product_html = _theme.Helpers.updateHtml(product_html, '[[Product_Handle]]', this.productHandle);
            product_html = _theme.Helpers.updateHtml(product_html, '[[Collection_Handle]]', this.collectionHandle);

            product_html = _theme.Helpers.updateHtml(product_html, '[[Product_Variant_Class]]', variantClass);
            product_html = _theme.Helpers.updateHtml(product_html, '[[Product_Grid_Class]]', this.buildGridClass(product));
            product_html = _theme.Helpers.updateHtml(product_html, '[[Product_Notify_Me_Btn]]', this.buildNotifyMeBtn(product));
            product_html = _theme.Helpers.updateHtml(product_html, '[[Product_GWP_Properties]]', this.getGwpProperties(product));
            
            product_html = _theme.Helpers.updateHtml(product_html, '[[Product_Labels]]', this.buildProductLabels(product));

            if(this.settings.renderOfferTemplate) {
                product_html = _theme.Helpers.updateHtml(product_html, '[[Product_Price_Offer]]', this.buildProductPriceOffer(product));
                product_html = _theme.Helpers.updateHtml(product_html, '[[Product_QV_ATC_Btn_Offer]]', this.buildProductQvAtcBtnOffer(product));
            } else {
                product_html = _theme.Helpers.updateHtml(product_html, '[[Product_Price]]', this.buildProductPrice(product));
                product_html = _theme.Helpers.updateHtml(product_html, '[[Product_QV_ATC_Btn]]', this.buildProductQvAtcBtn(product));
            }

            if(productImages.image_2) {
                product_html = _theme.Helpers.updateHtml(product_html, '[[Image_1_Class]]', 'images-one');
                product_html = _theme.Helpers.updateHtml(product_html, '[[Product_Image_2]]', productImages.image_2);
            } else {
                product_html = _theme.Helpers.updateHtml(product_html, '[[Image_1_Class]]', '');
                product_html = _theme.Helpers.updateHtml(product_html, '[[Product_Image_2]]', '');
            }

            if(count == 10 && !this.settings.isLoadMore){
                mainHtml += this.selectors.productsBannerTop.innerHTML; 
            }

            mainHtml += product_html;
        });

        if(this.settings.isLoadMore){
            const oldHtml = this.selectors.productsContainer.innerHTML;
            this.selectors.productsContainer.innerHTML = oldHtml + mainHtml;
            this.settings.isLoadMore = false;
        } else {
            this.selectors.productsContainer.innerHTML = mainHtml;
        }

        if (this.pageType === 'search') {
            this.closest('[data-search-container]').querySelector('[data-result-container]').classList.remove('hidden');
            this.closest('[data-search-container]').querySelector('[data-no-search-container]').classList.add('hidden');
        } else { 
            this.selectors.mainContainer.querySelector('[data-toolbar-container]').classList.remove('hidden');
            this.selectors.mainContainer.querySelector('[data-collection-info]').classList.remove('hidden');
            this.selectors.productsContainer.style.display = 'grid';
        }

        this.selectors.productCounts.forEach(countElem => {
            countElem.textContent = `(${result.totalItems} ${result.totalItems > 1 ? 'Products' : 'Product'})`;
        });
        this.selectors.viewAllBtnMob.innerHTML = `View (${result.totalItems})`;
    }
    renderFilters(result){
        if(!result || result.totalItems === 0) return;

        let mainHtml = '';
        let filterBtnLI = '';
        let filter_Selected = false;
        let price_from = 0, price_to = 0, price_from_left = 0, price_to_left = 0;

        result.facets.forEach((facet, facetIndex) => {
            let filterOptionMainHtml = '';
            let item_title = facet.title.trim().toLowerCase();

            let filterItemHtml = templates.filterItem; 
            filterItemHtml = _theme.Helpers.updateHtml(filterItemHtml, '[[FILTER_TITLE]]', facet.title);
            filterItemHtml = _theme.Helpers.updateHtml(filterItemHtml, '[[FILTER_ATTR_KEY]]', facet.attribute);
            
            let filter_selected_count = 0;
            let filter_open_accordion = false;
            facet.buckets.forEach((option, optionIndex) => {
                if(item_title == 'price') {
                    
                    price_from = Number(option.from);
                    price_to = Number(option.to);
                    price_from_left = Number(option.left);
                    price_to_left = Number(option.right);

                    const price_from_formatted = Shopify.formatMoney((price_from*100), window.money_format);
                    const price_to_formatted = Shopify.formatMoney((price_to*100), window.money_format);
                    const price_left_formatted = Shopify.formatMoney((price_from_left*100), window.money_format);
                    const price_right_formatted = Shopify.formatMoney((price_to_left*100), window.money_format);
                    let priceOptionHtml = templates.filterPriceOption;

                    priceOptionHtml = _theme.Helpers.updateHtml(priceOptionHtml, '[[PRICE_FROM_UNFORMATTED]]', price_from);
                    priceOptionHtml = _theme.Helpers.updateHtml(priceOptionHtml, '[[PRICE_TO_UNFORMATTED]]', price_to);
                    priceOptionHtml = _theme.Helpers.updateHtml(priceOptionHtml, '[[PRICE_LEFT]]', price_left_formatted);
                    priceOptionHtml = _theme.Helpers.updateHtml(priceOptionHtml, '[[PRICE_RIGHT]]', price_right_formatted);
                    priceOptionHtml = _theme.Helpers.updateHtml(priceOptionHtml, '[[PRICE_FROM]]', price_from_formatted);
                    priceOptionHtml = _theme.Helpers.updateHtml(priceOptionHtml, '[[PRICE_TO]]', price_to_formatted);
                    priceOptionHtml = _theme.Helpers.updateHtml(priceOptionHtml, '[[PRICE_FROM_TO_UNFORMATTED]]', 'restrictBy[price]=' + price_from +','+price_to);
                    filterOptionMainHtml += priceOptionHtml;

                } else {
                    let optionHtml = templates.filterOption;
                    optionHtml = _theme.Helpers.updateHtml(optionHtml, '[[FILTER_OPTION_ID]]', _theme.Helpers.handleize(`${facet.title}-${option.value}-${optionIndex}`));
                    optionHtml = _theme.Helpers.updateHtml(optionHtml, '[[FILTER_OPTION_VALUE]]', option.value);
                    optionHtml = _theme.Helpers.updateHtml(optionHtml, '[[FILTER_OPTION_TITLE]]', option.value +' ('+option.count+')');
                    optionHtml = _theme.Helpers.updateHtml(optionHtml, '[[FILTER_OPTION_SELECTED]]', option.selected === "true" ? "checked" : "");
                    filterOptionMainHtml += optionHtml;
                }
                if (option.selected === "true") {
                    filter_Selected = true;
                    filter_selected_count += 1;
                    filter_open_accordion = true;
                }
                if (facetIndex === 0 && !this.settings.isMobile) {
                    filter_open_accordion = true;
                }
            });
            
            filterItemHtml = _theme.Helpers.updateHtml(filterItemHtml, '[[FILTER_OPTIONS]]', filterOptionMainHtml);
            filterItemHtml = _theme.Helpers.updateHtml(filterItemHtml, '[[FILTER_SELECTED_COUNT]]', filter_selected_count > 0 ? `(${filter_selected_count})` : '');
            filterItemHtml = _theme.Helpers.updateHtml(filterItemHtml, '[[FILTER_ACCORDION_CLASS]]', filter_open_accordion ? 'open-accordion' : '');
            filterItemHtml = _theme.Helpers.updateHtml(filterItemHtml, '[[FILTER_ACCORDION_ATTR]]',  filter_open_accordion ? 'aria-expanded="true"' : 'aria-expanded="false"');
            filterItemHtml = _theme.Helpers.updateHtml(filterItemHtml, '[[FILTER_ACCORDION_STYLE]]', filter_open_accordion ? 'style="display:block"' : 'style="display:none"');
            mainHtml += filterItemHtml;

            filterBtnLI+= `<li role="listitem" data-title="${facet.title}">
                                <button type="button" aria-label="${facet.title} filter" data-desk-filter-open>${facet.title}</button>
                            </li>`;
        });

        this.selectors.filterContainer.innerHTML = mainHtml;

        this.selectors.filterButtons.innerHTML = `<ul role="list">
                                                    ${filterBtnLI}
                                                    <li role="listitem" data-title="clear">
                                                        <button type="button" aria-label="Clear All filter" class="clear-desk-filter" data-filter-clear-all>Clear All</button>
                                                    </li>
                                                </ul>`;
        
        this.selectors.viewAllBtnMob.classList.toggle('disabled', !filter_Selected);
        this.selectors.clearAllBtnMob.classList.toggle('disabled', !filter_Selected);

        this.selectors.overlay.addEventListener('click', this.closeMobSidebarFilter.bind(this));
        this.selectors.mobFilterOpen.addEventListener('click', this.openMobSidebarFilter.bind(this));
        this.selectors.mobFilterClose.forEach(btn => {
            btn.addEventListener('click', this.closeMobSidebarFilter.bind(this));
        });

        const filterContainerBtns = this.selectors.filterContainer.querySelectorAll('.sidebar-title');
        filterContainerBtns.forEach(btn => {
            btn.addEventListener('click', evt => {
                const parent = btn.closest('.widget');
                const title = parent.querySelector('.sidebar-title');
                const content = parent.querySelector('.widget-content');
                parent.classList.toggle('open-accordion');
        
                const isOpen = content.style.display === 'block';
                content.style.display = isOpen ? 'none' : 'block';
                title.setAttribute('aria-expanded', !isOpen);
            });
        });

        const filterInputs = this.selectors.filterContainer.querySelectorAll('[data-filter-option-container] input[type="checkbox"]');
        filterInputs.forEach(input => {
            input.addEventListener('change', (evt) => {
                this.settings.isPriceFilter = false;
                this.resetFilters();
                this.fetchProducts(false);
            });
        });

        if(price_from != undefined && price_to != undefined){
            const _this = this;
            $(document).ready(function() {
                jQuery( "#filter-price-range" ).slider({
                    range: true,
                    min: price_from,
                    max: price_to,
                    step: 0.1,
                    values: [ price_from_left, price_to_left ],

                    create: function(event, ui) {
                        jQuery('#filter-price-range .ui-slider-handle').attr("role", "button");
                        jQuery('#filter-price-range .ui-slider-handle').first().attr('aria-labelledby', 'price-selected-min');
                        jQuery('#filter-price-range .ui-slider-handle').last().attr('aria-labelledby', 'price-selected-max');
                    },
                    slide: function( event, ui ) {
                        const price_from_formatted = Shopify.formatMoney((ui.values[0]*100), window.money_format);
                        const price_to_formatted = Shopify.formatMoney((ui.values[1]*100), window.money_format);
                        jQuery('.price-selected .price-selected-min').text(price_from_formatted).find('.visually-hidden').text('minimum price ' + price_from_formatted);
                        jQuery('.price-selected .price-selected-max').text(price_to_formatted).find('.visually-hidden').text('minimum price ' + price_to_formatted);
                        jQuery('[data-filter-items] .price-range-full').val('restrictBy[price]=' + ui.values[0] +','+ ui.values[1]);

                        jQuery('.price-selected .price-selected-min').attr('data-min-price', price_from_formatted);
                        jQuery('.price-selected .price-selected-max').attr('data-max-price', price_to_formatted);
                    },
                    change: function( event, ui ) {
                        const price_from_formatted = Shopify.formatMoney((ui.values[0]*100), window.money_format);
                        const price_to_formatted = Shopify.formatMoney((ui.values[1]*100), window.money_format);
                        jQuery('.price-selected .price-selected-min').text(price_from_formatted).find('.visually-hidden').text('minimum price ' + price_from_formatted);
                        jQuery('.price-selected .price-selected-max').text(price_to_formatted).find('.visually-hidden').text('minimum price ' + price_to_formatted);
                        jQuery('[data-filter-items] .price-range-full').val('restrictBy[price]=' + ui.values[0] +','+ ui.values[1]);

                        jQuery('.price-selected .price-selected-min').attr('data-min-price',price_from_formatted);
                        jQuery('.price-selected .price-selected-max').attr('data-max-price',price_to_formatted);
                    },
                    stop: function( event, ui ) {
                        _this.settings.isPriceFilter = true;
                        _this.fetchProducts(false);
                    }
                });
            });
        }
    }
    resetFilters(){
        this.settings.startIndex = 0;
        this.settings.currentPage = 0;
        this.settings.isLoadMore = false;
    }

    async fetchSimilarProducts(startIndex, maxResults) {
        const similarApiUrl = 'https://searchserverapi.com/getwidgets?api_key=4R1a4a6e9W&output=jsonp&items=true&maxResults=1000&suggestions=true&suggestionsMaxResults=5&pages=true&pagesMaxResults=10&categories=true&categoryStartIndex=0&categoriesMaxResults=5';
        
        const response = await fetch(`${similarApiUrl}&q=${encodeURIComponent(this.searchQuery)}&startIndex=${startIndex}&maxResults=${maxResults}`);
        if (!response.ok) {
            throw new Error('Similar search failed');
        }
        
        return await response.json();
    }
    async trySimilarProducts() {
        try {
            const similarResult = await this.fetchSimilarProducts(this.settings.similarProductStartIndex, this.settings.similarProductItemsPerPage);
            
            if (similarResult.totalItems > 0) {
                this.showSimilarProducts(similarResult);
            } else {
                this.showNoSimilarProducts();
            }
        } catch (error) {
            this.showNoSimilarProducts();
        }
    }
    showSimilarProducts(result) {
        this.isShowingSimilarProducts = true;
        
        // Store the total count for pagination
        this.settings.similarProductTotalItems = result.totalItems;
        this.settings.similarProductCurrentPage = 0;
        this.settings.similarProductStartIndex = 0;
        
        // Reset loading flag for similar search
        this.settings.isLoading = false;
        
        // Render the products using existing method
        this.renderProducts(result);

        // Initialize infinite scroll for similar search
        this.initInfiniteScrollLoadMore(result);

        // Initialize Wishlist
        _theme.initSmartWishlist();

        this.selectors.mainContainer.querySelector('[data-toolbar-container]').classList.add('hidden');
    }
    showNoSimilarProducts() {
        this.closest('[data-search-container]').querySelector('[data-result-container]').classList.add('hidden');
        this.closest('[data-search-container]').querySelector('[data-no-search-container]').classList.remove('hidden');
    }
    async loadMoreSimilarProducts() {
        try {
            const similarResult = await this.fetchSimilarProducts(this.settings.similarProductStartIndex, this.settings.similarProductItemsPerPage);
            
            if (similarResult.totalItems > 0) {
                this.renderProducts(similarResult);
                // Reinitialize infinite scroll for next batch
                this.initInfiniteScrollLoadMore(similarResult);
            }
            
            this.settings.isLoading = false;
            _theme.toggleLoading(false);
        } catch (error) {
            console.error('Error loading more similar search results:', error);
            this.settings.isLoading = false;
            _theme.toggleLoading(false);
        }
    }

    initInitialEvents(){

        // Sort by
        const sortByItems = Array.from(this.selectors.sortByList.querySelectorAll('li'));
        sortByItems.forEach(sortItem => {
            sortItem.addEventListener('keydown', evt => {
                if(evt.key === "Enter"){
                    evt.preventDefault();
                    evt.stopPropagation();
                    evt.stopImmediatePropagation();
                    sortItem.click();
                }
                if(evt.key === "Tab"){
                    this.closeSortByMenu();
                }
            });

            sortItem.addEventListener('click', evt => {
                sortByItems.filter(item => item !== sortItem).forEach(item => {
                    item.setAttribute('aria-selected', false);
                    item.classList.remove('active');
                });
                
                const sortLabel = sortItem.getAttribute('data-text');
                this.selectors.sortByBtn.querySelector('.label-text').textContent = sortLabel;

                sortItem.setAttribute('aria-selected', true);
                sortItem.classList.add('active');

                this.closeSortByMenu();
                this.resetFilters();
                
                // Only fetch products if not showing similar products
                if (!this.isShowingSimilarProducts) {
                    this.fetchProducts(false);
                }
            });
        });

        this.selectors.sortByBtn.addEventListener('click', (evt) => {
            const isOpen = JSON.parse(this.selectors.sortByBtn.getAttribute('aria-expanded'));
            if(isOpen){
                this.closeSortByMenu(evt.target);
            } else {
                this.openSortByMenu(evt.target);
            }
        });
        this.selectors.sortByDiv.addEventListener('keyup', evt => {
            evt.preventDefault();
            evt.stopPropagation();
            evt.stopImmediatePropagation();

            let selectedElem = this.selectors.sortByList.querySelector('li[aria-selected="true"]');
            if(!selectedElem) selectedElem = this.selectors.sortByList.querySelector('li');

            const nextElem = selectedElem.nextElementSibling;
            const prevElem = selectedElem.previousElementSibling;
            const target = evt.target;

            if(evt.key === "Escape"){
                this.closeSortByMenu();
                this.selectors.sortByBtn.focus();
            }

            if(evt.key === "Tab" && !this.selectors.sortByDiv.contains(target)){
                this.closeSortByMenu();
            }

            if(evt.key === "ArrowDown" && nextElem){
                evt.preventDefault();
                selectedElem.setAttribute('aria-selected', false);
                nextElem.setAttribute('aria-selected', true);
                nextElem.focus();
            }

            if(evt.key === "ArrowUp" && prevElem){
                evt.preventDefault();
                selectedElem.setAttribute('aria-selected', false);
                prevElem.setAttribute('aria-selected', true);
                prevElem.focus();
            }
        });

        // Clear All
        this.selectors.clearAllBtns.forEach(btn => {
            btn.addEventListener('click', evt => {

                const filterInputs = this.selectors.filterContainer.querySelectorAll('[data-filter-option-container] input[type="checkbox"]');
                filterInputs.forEach(input => {
                    input.checked = false;
                });

                this.settings.isPriceFilter = false;
                this.resetFilters();
                this.fetchProducts(false);
            });
        });
        
        document.body.addEventListener('click', evt => {
            const target = evt.target;
            const sortBy = this.querySelector('[data-sortby]');
            if(target !== sortBy && !sortBy.contains(target)){
                this.closeSortByMenu();
            }
        });
    }
    initInfiniteScrollLoadMore(result){
        // Handle similar search pagination
        if (this.isShowingSimilarProducts) {
            const totalItems = this.settings.similarProductTotalItems || result.totalItems;
            const itemsPerPage = this.settings.similarProductItemsPerPage;
            const total_page = Math.ceil(totalItems / itemsPerPage);

            this.settings.similarProductStartIndex = result.startIndex || 0;
            if (this.settings.similarProductCurrentPage >= total_page || totalItems <= itemsPerPage) return;

            const totalLoadedProducts = this.settings.similarProductStartIndex + itemsPerPage;
            if (totalLoadedProducts >= totalItems) return;
        } else {
            // Regular pagination
            const totalItems = result.totalItems;
            const itemsPerPage = result.itemsPerPage;
            const total_page = Math.ceil(totalItems / itemsPerPage);

            this.settings.startIndex = result.startIndex;
            if(this.settings.currentPage >= total_page || totalItems <= itemsPerPage) return;

            const totalLoadedProducts = this.settings.startIndex + itemsPerPage;
            if(totalLoadedProducts >= totalItems) return;
        }

        const viewportBtm = ((window.innerHeight * 40)/100) + 'px';
        const config = {
            root: null,
            rootMargin: `0px 0px ${viewportBtm} 0px`,
            threshold: 0.05
        };

        this.settings.infiniteScrollObserver = new IntersectionObserver((entries, observer) => {
            if(this.settings.isLoading) return;

            if(entries[0].isIntersecting){
                this.settings.isLoadMore = true;
                
                if (this.isShowingSimilarProducts) {
                    // Similar search pagination
                    this.settings.similarProductCurrentPage++;
                    this.settings.similarProductStartIndex = this.settings.similarProductCurrentPage * this.settings.similarProductItemsPerPage;
                } else {
                    // Regular pagination
                    this.settings.currentPage++;
                    this.settings.startIndex = this.settings.currentPage * result.itemsPerPage;
                }

                observer.unobserve(this.selectors.loadMoreBtn);
                this.fetchProducts(false);
            }
        }, config);

        this.settings.infiniteScrollObserver.observe(this.selectors.loadMoreBtn);
    }

    isTimerActive(timerSettings) {
      if (
        !timerSettings.enabled ||
        !timerSettings.startDate ||
        !timerSettings.startTime ||
        !timerSettings.endDate ||
        !timerSettings.endTime
      ) {
        return false;
      }

      // Get current time in EST/EDT
      const currentDateEST = _theme.Helpers.getCurrentESTTime();

      const startDateTime = _theme.Helpers.parseESTDate(timerSettings.startDate, timerSettings.startTime).getTime();
      const endDateTime = _theme.Helpers.parseESTDate(timerSettings.endDate, timerSettings.endTime).getTime();

      const isActive = currentDateEST >= startDateTime && currentDateEST <= endDateTime;

      return isActive;
    }

    buildProductImage(product){
        const featured_image = product.image_link || 'https://cdn.shopify.com/shopifycloud/shopify/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c.gif';
        const image_1 = `<img src="${featured_image}" alt="${product.title} Featured image" class="lazyload" />`;

        let image_2 = '';
        if(product.shopify_images && product.shopify_images.length > 1){
            image_2 = `<div class="images-two"><img src="${product.shopify_images[1]} Secondary image" alt="${product.title}" class="lazyload" /></div>`;

        }

        return { image_1, image_2 };
    }
    buildProductLabels(product) {
        let priceHtml = '';
        const maxDiscountData = this.getMaxDiscountAndvariant(product);
        const variant = maxDiscountData.maxDiscountVariant;
        const flashVariants = product.shopify_variants.filter(
            (variant) =>
                variant.search_variant_metafields_data?.variant_metafield_7196e689a0a0c382ce7f6b23dbe610ca === 'true' &&
                variant?.available !== '0'
        );

        // Check if timer is active and flash sale extension shop metafield is active
        const timerSettings = window.countdownTimerSettings || {};
        const isTimerActive = this.isTimerActive(timerSettings);
        const flashSaleExtensionActive = timerSettings.flashSaleExtensionActive === true;

        if (flashVariants.length > 0 && isTimerActive && flashSaleExtensionActive) {
            const per = Math.round(parseFloat(flashVariants[0].list_price) - parseFloat(flashVariants[0].price));
            priceHtml = `
                    <span class="badge price__badge-sale">
                        <span class="noun-discount">
                            <img src="//fragrancemarket.com/cdn/shop/files/noun-discount.svg?v=16528122525495080232" alt="discount">
                        </span> $${per} Off <span class="visually-hidden"> Discount</span>      
                    </span>`;
        } else if (variant && maxDiscountData.maxDiscount) {
            const per = maxDiscountData.maxDiscount;
            priceHtml = `<span class="new-tag-style blue-badge-style">Save Up To $${per}</span>`;
        }

        let offerHtml = '';
        let offerCount = 1;
        const productTags = product.tags;

        if (productTags && productTags !== '') {
            const tags = productTags.split('[:ATTR:]');
            const tagsStr = productTags.trim().toLowerCase();
            
            // Check if timer is active and shop metafield is active
            const timerSettings = window.countdownTimerSettings || {};
            const isTimerActive = this.isTimerActive(timerSettings);
            const flashSaleExtensionActive = timerSettings.flashSaleExtensionActive === true;

            // Show flash sale timer if variant has flash sale metafield, timer is active, and shop metafield is active
            if (flashVariants.length > 0 && isTimerActive && flashSaleExtensionActive) {
                offerCount = 2;
                const startDate = timerSettings.startDate || '';
                const startTime = timerSettings.startTime || '';
                const endDate = timerSettings.endDate || '';
                const endTime = timerSettings.endTime || '';
                offerHtml = `<div class="offer-tag-style flash-sale product-tag-style" role="status" aria-label="Flash sale promotion"><span class="flash-sale-wrapper"><img alt="Flash Sale Icon" src="//fragrancemarket.com/cdn/shop/files/flash-icon.png?v=11919913765476859936">Flash Sale</span> <span class='flash-separator' aria-hidden='true'></span> <countdown-timer data-start-date='${startDate}' data-start-time='${startTime}' data-end-date='${endDate}' data-end-time='${endTime}' data-replace-days-with-hours='${window.replace_days_with_hours}' data-location='product-grid' role='timer' aria-live='polite' aria-label='Flash sale countdown timer' tabindex='0'><span class='flash-timer-text'>00:00:00</span></countdown-timer></div>`;
            } else {
                const productOffer = product.metafield_b9ba57cd478d42c60429674e481c50c1;

                // Check if variant metafield structure exists and has available offer variant
                const hasMetafieldStructure = product.shopify_variants?.some(
                    variant => variant.search_variant_metafields_data?.hasOwnProperty('variant_metafield_25c7b979d6abf42fb11a9be16739134f')
                );
                    
                // Check if any variant has is_offer_applicable = "true" (string) AND available !== "0"
                const hasOfferVariant = hasMetafieldStructure && product.shopify_variants?.some(
                    v => v.search_variant_metafields_data?.variant_metafield_25c7b979d6abf42fb11a9be16739134f === "true" && v.available !== "0"
                );

                if(productOffer === '2 For $99' && hasOfferVariant) {
                        offerCount = 2;
                        offerHtml += `<span class="customOff new blue-badge-style">
                                        2 for $99 | Mix & Match
                                    </span>`;
                }

                if (offerCount < 2 && tagsStr.includes('online-only-item')) {
                    offerCount = 2;
                    offerHtml = `<span class='new-tag-style badge-style'>Online Only</span>`;
                } else if (offerCount < 2 && tagsStr.includes('best-sellers')) {
                    offerCount = 2;
                    offerHtml = `<span class='new-tag-style badge-style'>Best Seller</span>`;
                }
            }
        }

        // Check if timer is active and flash sale extension shop metafield is active
        const timerSettingsFinal = window.countdownTimerSettings || {};
        const isTimerActiveFinal = this.isTimerActive(timerSettingsFinal);
        const flashSaleExtensionActiveFinal = timerSettingsFinal.flashSaleExtensionActive === true;

        if (flashVariants.length > 0 && isTimerActiveFinal && flashSaleExtensionActiveFinal) {
            document.querySelectorAll('.product-list-flash-badge').forEach((el) => {
            el.closest('.product-top')?.classList.add('flash-sale-active-badge');
            });
            return priceHtml !== '' || offerHtml !== ''
            ? `<div class="product-tags-wrap product-price-grid product-list-flash-badge">${offerHtml}${priceHtml}</div>`
            : '';
        } else {
            return priceHtml !== '' || offerHtml !== ''
            ? `<div class="product-tags-wrap">${priceHtml}${offerHtml}</div>`
            : '';
        }
    }
    
    buildProductPrice(product){
        let html = '';
        const isAvailable = this.isProductAvailable(product);
        const variant = this.getFirstAvailableVariant(product);

        if(variant) {
            let price = Shopify.formatMoney((variant.price * 100), window.money_format);
            let cprice = Shopify.formatMoney((variant.list_price * 100), window.money_format);

            if (parseFloat(variant.list_price) > parseFloat(variant.price)) {
                html = `<div class="priceContainer">
                            <div class="priceRange">
                                <div class="price-list">
                                    <span class="visually-hidden visually-hidden--inline">Sale Price</span>
                                    ${price}
                                    <span class="visually-hidden">Regular Price</span>
                                    <span class="del-price price-item--regular" aria-hidden="false">${cprice}</span>
                                </div>
                            </div>
                        </div>`;
            } else {
                html = `<div class="price-list">
                            <span class="visually-hidden visually-hidden--inline">Sale Price</span>
                            ${price}
                        </div>`;
            }
        }

        let prices = product.shopify_variants.map(function(v){ return Number(v.price); });
        if(prices.length > 1) {
            const min_price = Math.min.apply(null, prices);
            const max_price = Math.max.apply(null, prices);

            if(min_price !== max_price) {
                const min_price_formatted = Shopify.formatMoney((min_price*100), window.money_format);
                const max_price_formatted = Shopify.formatMoney((max_price*100), window.money_format);
                html =  `<div class="priceContainer">
                            <div class="priceRange">
                                <span class="visually-hidden">Price range from ${min_price_formatted} to ${max_price_formatted}</span> 
                                <span aria-hidden="true">${min_price_formatted} - ${max_price_formatted}</span>
                            </div>
                        </div>`;
            }
        }

        if(!isAvailable) html = '';
        return html;
    }
    buildProductQvAtcBtn(product) {
      let html = '';
      const flashVariants = product.shopify_variants.filter(
        (variant) =>
          variant.search_variant_metafields_data?.variant_metafield_7196e689a0a0c382ce7f6b23dbe610ca === 'true' &&
          variant?.available !== '0'
      );

      let variant = this.getFirstAvailableVariant(product);
      // Check if timer is active and flash sale extension shop metafield is active
      const timerSettings = window.countdownTimerSettings || {};
      const isTimerActive = this.isTimerActive(timerSettings);
      const flashSaleExtensionActive = timerSettings.flashSaleExtensionActive === true;
      
      if (flashVariants.length > 0 && isTimerActive && flashSaleExtensionActive) {
        variant = flashVariants[0];
      }

      const isAvailable = this.isProductAvailable(product);

      // agar product kaa variant ek hi hai aur product available nahi ho toh bhi quickview text show karao
      let label;
      if (product.shopify_variants.length === 1) {
          label = isAvailable ? 'Add To Cart' : 'Quick View';
      } else {
          label = 'Quick View';
      }
      html = `<div class="offer-wrapper  fix-bottom">
                    <div class="d-flex justify-content-between grid-btns">
                        <button type="button" class="offer-quickview-mob-button hide-desk" aria-label="${label} ${product.title}"
                            data-vid="${variant.variant_id}" data-id="qv-${product.product_id}" data-url="${product.link}" data-mobile-quickview-button
                        >
                            <span>${label}</span>
                        </button>

                        <button type="button" class="offer-quickview-mob-button hide-mob" aria-label="${label} ${product.title}"
                            data-vid="${variant.variant_id}" data-id="qv-${product.product_id}" data-url="${product.link}" data-default-quickview-button
                        >
                            <span>${label}</span>
                        </button>
                    </div>
                </div>`;

      return html;
    }

    buildProductPriceOffer(product) {
      let html = '';
      let variant = this.getFirstAvailableVariant(product);

      const flashVariants = product.shopify_variants.filter(
        (variant) =>
          variant.search_variant_metafields_data?.variant_metafield_7196e689a0a0c382ce7f6b23dbe610ca === 'true' &&
          variant?.available !== '0'
      );

      // Check if timer is active and flash sale extension shop metafield is active
      const timerSettings = window.countdownTimerSettings || {};
      const isTimerActive = this.isTimerActive(timerSettings);
      const flashSaleExtensionActive = timerSettings.flashSaleExtensionActive === true;

      if (flashVariants.length > 0 && isTimerActive && flashSaleExtensionActive) {
        variant = flashVariants[0];
      }
      if (variant) {
        const price = Shopify.formatMoney(variant.price * 100, window.money_format);
        const cprice = Shopify.formatMoney(variant.list_price * 100, window.money_format);

        if (parseFloat(variant.list_price) > parseFloat(variant.price)) {
          html = `<div class="priceContainer">
                                <div class="priceRange">
                                    <span class="visually-hidden">Sale Price</span>
                                    ${price}
                                    <span class="line-through">
                                        <span class="visually-hidden">Regular Price</span>
                                        ${cprice}
                                    </span>
                                </div>
                                  <span class="variant cmVariant" data-id="${variant.variant_id}">
                                    <span class="">Size :</span>
                                    ${variant.options.Size}
                                </span>
                            </div>`;
        } else {
          html = `<div class="priceContainer">
                                <div class="priceRange">
                                    <span class="visually-hidden">Sale Price</span>
                                    ${price}
                                </div>
                            </div>`;
        }
      }

      return html;
    }
    buildProductQvAtcBtnOffer(product) {
      let html = '';
      let btnHtml = '';
      let variant = this.getFirstAvailableVariant(product);

      const iconQuickview = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                                <path d="M15 12c0 1.654-1.346 3-3 3s-3-1.346-3-3 1.346-3 3-3 3 1.346 3 3zm9-.449s-4.252 8.449-11.985 8.449c-7.18 0-12.015-8.449-12.015-8.449s4.446-7.551 12.015-7.551c7.694 0 11.985 7.551 11.985 7.551zm-7 .449c0-2.757-2.243-5-5-5s-5 2.243-5 5 2.243 5 5 5 5-2.243 5-5z"></path>
                            </svg>`;

      if (variant.available == '1') {
        const flashVariants = product.shopify_variants.filter(
          (variant) =>
            variant.search_variant_metafields_data?.variant_metafield_7196e689a0a0c382ce7f6b23dbe610ca === 'true' &&
            variant?.available !== '0'
        );

        // Check if timer is active and flash sale extension shop metafield is active
        const timerSettings = window.countdownTimerSettings || {};
        const isTimerActive = this.isTimerActive(timerSettings);
        const flashSaleExtensionActive = timerSettings.flashSaleExtensionActive === true;
        
        let offer_quickview_attr = 'data-offer-quickview-button';
        if (flashVariants.length > 0 && isTimerActive && flashSaleExtensionActive) {
          offer_quickview_attr = 'data-default-quickview-button';
          variant = flashVariants[0];
        }
        btnHtml = `<div class="d-flex justify-content-between grid-btns">
                        <button class="cm-add-bndle btn"> Add To Cart </button>

                        <button type="button" aria-label="Quick View ${product.title}" class="offer-quickview-mob-button hide-desk" 
                            data-id="qv-${product.product_id}" data-vid="${variant.variant_id}" data-url="${product.link}" data-mobile-quickview-button
                        >
                            ${iconQuickview}
                        </button>

                        <button type="button" aria-label="Quick View ${product.title}" class="offer-quickview-button hide-mob" 
                            data-id="${this.productHandle}" data-vid="${variant.variant_id}" data-url="${product.link}" ${offer_quickview_attr}
                        >
                            ${iconQuickview}
                        </button>
                    </div>`;
      }

      html = `<div class=" offer-wrapper ">
                    <span class="variant cmVariant" data-id="${variant.variant_id}">
                        <span class="visually-hidden">Size </span>
                        ${variant.options.Size}
                    </span>
                    ${btnHtml}
                </div>`;

      return html;
    }

    buildNotifyMeBtn(product){
        let html = '';
        const isAvailable = this.isProductAvailable(product);
    
        if (!isAvailable) {
            let notifyHTML = _theme.product_html.notify_me;
            notifyHTML = _theme.Helpers.updateHtml(notifyHTML, '[[notify_me_product_id]]', product.product_id);
            html = notifyHTML;
        }
        
        return html;
    }
    buildGridClass(product) {
        let html = '';
        const isAvailable = this.isProductAvailable(product);
    
        html = isAvailable ? 'available' : 'sold_out';
        return html;
    }
    updateSRStatus(){
        if(this.settings.isLoading){
            this.selectors.srStatus.textContent = "Content is loading";
        } else {
            this.selectors.srStatus.textContent = "Content loaded successfully";
        }
    } 

    isProductAvailable(product) {
        const productOffer = product.metafield_b9ba57cd478d42c60429674e481c50c1;

        if(productOffer && productOffer !== '' && productOffer !== null && this.settings.renderOfferTemplate) { 
            const isAvailable = product.shopify_variants.find(
                variant => variant.search_variant_metafields_data?.variant_metafield_25c7b979d6abf42fb11a9be16739134f === "true" && variant.available !== "0"
            );

            return isAvailable ? true : false;
        } else {
            const isAvailable = product.shopify_variants.some(function(variant) {
                return variant.available !== "0";
            });
        
            return isAvailable ? true : false;
        }
    }

    getGwpProperties(product) {
        let html = '';
        if (!product) return;
  
        // Check if any variant has the metafield structure first
        const hasMetafieldStructure = product.shopify_variants?.some(
          (variant) => variant.search_variant_metafields_data?.hasOwnProperty('variant_metafield_25c7b979d6abf42fb11a9be16739134f')
        );
  
        if (hasMetafieldStructure) {
          // Find variant with is_offer_applicable = true using Searchanise metafield structure
          const offerVariant = product.shopify_variants?.find(
            v => v.search_variant_metafields_data?.variant_metafield_25c7b979d6abf42fb11a9be16739134f === "true" && v.available !== "0"
          );
  
          if (offerVariant) {
            html += `<input type="hidden" name="properties[_bundleVarId]" value="${offerVariant.variant_id}" data-bundleVarId>`;
          }
        }
  
        return html;
    }
    getFirstAvailableVariant(product) {
        const productOffer = product.metafield_b9ba57cd478d42c60429674e481c50c1;

        // Check for flash sale variants first (highest priority)
        const flashVariants = product.shopify_variants.filter(
            (variant) =>
                variant.search_variant_metafields_data?.variant_metafield_7196e689a0a0c382ce7f6b23dbe610ca === 'true' &&
                variant?.available !== '0'
        );

        const timerSettings = window.countdownTimerSettings || {};
        const isTimerActive = this.isTimerActive(timerSettings);
        const flashSaleExtensionActive = timerSettings.flashSaleExtensionActive === true;

        // Check if any flash variant exists and timer is active and flash sale extension shop metafield is active
        if (flashVariants.length > 0 && isTimerActive && flashSaleExtensionActive) {
            const bundleIdVariant = flashVariants[0];
            return bundleIdVariant;
        }

        if(productOffer && productOffer !== '' && productOffer !== null && this.settings.renderOfferTemplate) {
            // Find the variant with offer applicable metafield that is available
            const offerVariant = product.shopify_variants.find(
                variant => variant.search_variant_metafields_data?.variant_metafield_25c7b979d6abf42fb11a9be16739134f === "true" && variant.available !== "0"
            );

            return offerVariant || product.shopify_variants[0];

        } else {
            // Find the first variant that is available (not "0")
            const availableVariant = product.shopify_variants.find(
                variant => variant.available !== "0"
            );            

            // If no variant is available, return the first variant
            return availableVariant || product.shopify_variants[0];
        }
        
    }
    getMaxDiscountAndvariant(product){
        let maxDiscount = 0, maxDiscountVariant = null;
        let availableMaxDiscount = 0, availableMaxDiscountVariant = null;

        product.shopify_variants && product.shopify_variants.length > 0 && product.shopify_variants.forEach(function(v) {
            const maxPrice = Number(v.list_price);
            if(!maxPrice || maxPrice <= 0) return false;

            const price = Number(v.price);
            const discountPer = Math.ceil(((maxPrice - price)));

            if(discountPer > maxDiscount) {
                maxDiscount = discountPer;
                maxDiscountVariant = v;
            }
            if(discountPer > availableMaxDiscount && Number(v.available)){
                availableMaxDiscount = discountPer;
                availableMaxDiscountVariant = v;
            }
        });

        const discountAmt = Number(product.discount);
        const productListPrice = Number(product.list_price);

        if(!maxDiscount && discountAmt > 0 && productListPrice > 0) {
            const per = Math.floor(((product.list_price - product.price)));
            maxDiscount = discountAmt || per;
        }

        return {
            maxDiscount: maxDiscount,
            maxDiscountVariant: maxDiscountVariant,
            availableMaxDiscount: availableMaxDiscount,
            availableMaxDiscountVariant: availableMaxDiscountVariant
        }
    }
    
    // Show product
    // openShowMenu(){
    //     this.selectors.showList.style.display = "block";
    //     this.selectors.showBtn.setAttribute('aria-expanded', true);
        
    //     const showMenuActiveItem = this.selectors.showList.querySelector('.active[aria-selected="true"]');
    //     if(showMenuActiveItem) {
    //         showMenuActiveItem.focus();
    //     }
    // }
    // closeShowMenu(){
    //     this.selectors.showList.style.display = "none";
    //     this.selectors.showBtn.setAttribute('aria-expanded', false);
        
    //     const selectedCurrent = this.selectors.showList.querySelector('.selected-current');
    //     if(selectedCurrent) selectedCurrent.classList.remove('selected-current');
    // }

    // Sortby product
    openSortByMenu(){
        this.selectors.sortByList.style.display = "block";
        this.selectors.sortByBtn.setAttribute('aria-expanded', true);

        const sortMenuActiveItem = this.selectors.sortByList.querySelector('.option-current[aria-selected="true"]');
        if(sortMenuActiveItem) {
            sortMenuActiveItem.focus();
        }
    }
    closeSortByMenu(){
        this.selectors.sortByList.style.display = "none";
        this.selectors.sortByBtn.setAttribute('aria-expanded', false);
    }

    // Sidebar Filter
    openMobSidebarFilter(target){
        this.querySelector('[data-mobile-filter]').classList.add('show');
        this.selectors.overlay.classList.add('active');
        this.selectors.overlay.style.cssText = 'z-index: 20 !important;';
        document.body.style.cssText = 'overflow: hidden !important;';
        document.html.style.cssText = 'overflow: hidden !important;';

        _theme.focusTrap($('.sidebar-mob'), (e) => {
            this.closeMobSidebarFilter();
            target.focus();
        });
    }
    closeMobSidebarFilter(){
        this.querySelector('[data-mobile-filter]').classList.remove('show');
        this.selectors.overlay.classList.remove('active');
        this.selectors.overlay.style.zIndex = '10';
        document.body.style.cssText = 'overflow: auto !important;';
        document.html.style.cssText = 'overflow: auto !important;';
    }
    
}
customElements.define('searchanize-products',SearchanizeProducts)
  
})();